import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    Redirect,
    Route,
    Switch,
} from 'react-router-dom';

import { IAsyncData } from '../models';
import { AgencyPage } from '../modules/Agency/components';
import { CareersPage } from '../modules/Careers/components';
import { Apply } from '../modules/Careers/components/Apply';
import { Contact } from '../modules/Contacts/components/index';
import { SendMessage } from '../modules/Contacts/components/SendMessage/index';
import { IContactDetails } from '../modules/Contacts/models';
import { ContactActions } from '../modules/Contacts/store/actions';
import { HomePage } from '../modules/Home/components/index';
import { LoginForm } from '../modules/Login/components/LoginForm';
import { Projects } from '../modules/Projects/components/index';
import { SingleProject } from '../modules/Projects/components/Project/index';
import { IApplicationState } from '../store/models';
import { isInitial } from '../utils';
import { ROUTES } from './consts';

export const ApplicationRoutes: React.FC = () => {
    const dispatch = useDispatch();
    const configurationBranch = useSelector<IApplicationState, IAsyncData<IContactDetails>>((state) => state.contact.configuration);

    React.useEffect(
        () => {
            if (isInitial(configurationBranch)) {
                dispatch(ContactActions.getConfig());
            }
        }
    );

    return (
        <Route
            path="/"
            render={() => (
                <Switch>
                    <Route path={ROUTES.AGENCY} component={AgencyPage} exact />
                    <Route path={ROUTES.HOME} component={HomePage} exact />
                    <Route path={ROUTES.CAREERS_APPLY} component={Apply} exact />
                    <Route path={ROUTES.CAREERS} component={CareersPage} exact />
                    <Route path={ROUTES.PROJECT} component={SingleProject} exact />
                    <Route path={ROUTES.PROJECTS} component={Projects} exact />
                    <Route path={ROUTES.LOGIN} component={LoginForm} exact />
                    <Route path={ROUTES.CONTACT.MAIN} component={Contact} exact />
                    <Route path={ROUTES.CONTACT.SEND_MESSAGE} component={SendMessage} exact />
                    <Redirect to={ROUTES.HOME} />
                </Switch >
            )}
        />
    );
};
